Vendd.Scripts.load(function () {

    var timelines = $('.cd-horizontal-timeline'),
		eventsMinDistance = 70;

	(timelines.length > 0) && initTimeline(timelines);

	function initTimeline(timelines) {
		timelines.each(function(){
			var timeline = $(this), timelineComponents = {};
			//cache timeline components 
			timelineComponents.timelineWrapper = timeline.find('.events-wrapper');
			timelineComponents.eventsWrapper = timelineComponents.timelineWrapper.children('.events');
			timelineComponents.fillingLine = timelineComponents.eventsWrapper.children('.filling-line');
			timelineComponents.timelineEvents = timelineComponents.eventsWrapper.find('a');
			timelineComponents.timelineNavigation = timeline.find('.cd-timeline-navigation');
			timelineComponents.eventsContent = timeline.children('.events-content');

			initDatesAndDistances(timelineComponents, timelineComponents.timelineEvents);

			//assign a left postion to the single events along the timeline
			setDatePosition(timelineComponents, eventsMinDistance);

			//assign a width to the timeline
			var timelineTotWidth = setTimelineWidth(timelineComponents, eventsMinDistance);
			//the timeline has been initialize - show it
			timeline.addClass('loaded');

			//detect click on the next arrow
			timelineComponents.timelineNavigation.on('click', '.next', function(event){
				event.preventDefault();
				updateSlide(timelineComponents, timelineTotWidth, 'next');
			});
			//detect click on the prev arrow
			timelineComponents.timelineNavigation.on('click', '.prev', function(event){
				event.preventDefault();
				updateSlide(timelineComponents, timelineTotWidth, 'prev');
			});
			//detect click on the a single event - show new event content
			timelineComponents.eventsWrapper.on('click', 'a', function(event){
				event.preventDefault();
				timelineComponents.timelineEvents.removeClass('selected');
				$(this).addClass('selected');
				updateOlderEvents($(this));
				updateFilling($(this), timelineComponents.fillingLine, timelineTotWidth);
				updateVisibleContent($(this), timelineComponents.eventsContent);
			});

			//on swipe, show next/prev event content
			timelineComponents.eventsContent.on('swipeleft', function(){
				var mq = checkMQ();
				( mq == 'mobile' ) && showNewContent(timelineComponents, timelineTotWidth, 'next');
			});
			timelineComponents.eventsContent.on('swiperight', function(){
				var mq = checkMQ();
				( mq == 'mobile' ) && showNewContent(timelineComponents, timelineTotWidth, 'prev');
			});

			//keyboard navigation
			$(document).keyup(function(event){
				if(event.which=='37' && elementInViewport(timeline.get(0)) ) {
					showNewContent(timelineComponents, timelineTotWidth, 'prev');
				} else if( event.which=='39' && elementInViewport(timeline.get(0))) {
					showNewContent(timelineComponents, timelineTotWidth, 'next');
				}
			});

			updateTimelineBoxNavigation(timelineComponents.timelineWrapper.find('.selected'),timelineComponents.eventsContent.find('.selected'));

			timelineComponents.eventsContent.on('click', '.prev, .next', function(e){
				date = $(this).find('.text').text();
				if ($(this).hasClass('next')) {
					string = 'next';
				}else {
					string = 'prev';
				}
				timelineComponents.eventsWrapper.find('a[data-date="' + date +'"]').click();
				var selectedDate = timelineComponents.eventsWrapper.find('.selected'),
				newEvent = ( string == 'next' ) ? selectedDate.parent('li').next('li').children('a') : selectedDate.parent('li').prev('li').children('a');
				updateTimelinePosition(string, newEvent, timelineComponents);
			});
		});
	}


	//kv edit
	function initAccordion() {

		$(".title-container .js-info-toggle-btn").click(function(e) {
			$(".intro").toggleClass("visible"); 
			$(this).toggleClass('icon-plus icon-minus');
		});
    }

	initAccordion();
	//kv edit end


	function updateSlide(timelineComponents, timelineTotWidth, string) {
		//retrieve translateX value of timelineComponents.eventsWrapper
		var translateValue = getTranslateValue(timelineComponents.eventsWrapper),
			wrapperWidth = Number(timelineComponents.timelineWrapper.css('width').replace('px', ''));
		//translate the timeline to the left('next')/right('prev') 
		(string == 'next') 
			? translateTimeline(timelineComponents, translateValue - wrapperWidth + eventsMinDistance, wrapperWidth - timelineTotWidth)
			: translateTimeline(timelineComponents, translateValue + wrapperWidth - eventsMinDistance);
	}

	function showNewContent(timelineComponents, timelineTotWidth, string) {
		//go from one event to the next/previous one
		var visibleContent =  timelineComponents.eventsContent.find('.selected'),
			newContent = ( string == 'next' ) ? visibleContent.next() : visibleContent.prev();

		if ( newContent.length > 0 ) { //if there's a next/prev event - show it
			var selectedDate = timelineComponents.eventsWrapper.find('.selected'),
				newEvent = ( string == 'next' ) ? selectedDate.parent('li').next('li').children('a') : selectedDate.parent('li').prev('li').children('a');
			
			updateFilling(newEvent, timelineComponents.fillingLine, timelineTotWidth);
			updateVisibleContent(newEvent, timelineComponents.eventsContent);
			newEvent.addClass('selected');
			selectedDate.removeClass('selected');
			updateOlderEvents(newEvent);
			updateTimelinePosition(string, newEvent, timelineComponents);
		}
	}

	function updateTimelinePosition(string, event, timelineComponents) {
		//translate timeline to the left/right according to the position of the selected event
		var eventStyle = window.getComputedStyle(event.get(0), null),
			eventLeft = Number(eventStyle.getPropertyValue("left").replace('px', '')),
			timelineWidth = Number(timelineComponents.timelineWrapper.css('width').replace('px', '')),
			timelineTotWidth = Number(timelineComponents.eventsWrapper.css('width').replace('px', ''));
		var timelineTranslate = getTranslateValue(timelineComponents.eventsWrapper);

        if( (string == 'next' && eventLeft > timelineWidth - timelineTranslate) || (string == 'prev' && eventLeft < - timelineTranslate) ) {
        	translateTimeline(timelineComponents, - eventLeft + timelineWidth/2, timelineWidth - timelineTotWidth);
        }
	}

	function translateTimeline(timelineComponents, value, totWidth) {
		var eventsWrapper = timelineComponents.eventsWrapper.get(0);
		value = (value > 0) ? 0 : value; //only negative translate value
		value = ( !(typeof totWidth === 'undefined') &&  value < totWidth ) ? totWidth : value; //do not translate more than timeline width
		setTransformValue(eventsWrapper, 'translateX', value+'px');
		//update navigation arrows visibility
		(value == 0 ) ? timelineComponents.timelineNavigation.find('.prev').addClass('inactive') : timelineComponents.timelineNavigation.find('.prev').removeClass('inactive');
		(value == totWidth ) ? timelineComponents.timelineNavigation.find('.next').addClass('inactive') : timelineComponents.timelineNavigation.find('.next').removeClass('inactive');
	}

	function updateFilling(selectedEvent, filling, totWidth) {
		//change .filling-line length according to the selected event
		var eventStyle = window.getComputedStyle(selectedEvent.get(0), null),
			eventLeft = eventStyle.getPropertyValue("left"),
			eventWidth = eventStyle.getPropertyValue("width");
		eventLeft = Number(eventLeft.replace('px', '')) + Number(eventWidth.replace('px', ''))/2;
		var scaleValue = eventLeft/totWidth;
		setTransformValue(filling.get(0), 'scaleX', scaleValue);
	}

	function setDatePosition(timelineComponents, min) {
	    var pixels = 0;
	    for (i = 0; i < timelineComponents.timelineDates.length; i++) {
	        var distanceNorm, eventWidth;
	        if (i == 0) {
	            pixels = min;
	        } else {
	            distanceNorm = timelineComponents.timelineDistances[i - 1];
	            eventWidth = timelineComponents.timelineEvents.eq(i - 1).width();
	            pixels = pixels + eventWidth + distanceNorm * min;
	        }
	        timelineComponents.timelineEvents.eq(i).css('left', pixels + 'px');
		}
	}

	function setTimelineWidth(timelineComponents, width) {
	    var totalWidth = 0;
	    for (i = 0; i < timelineComponents.timelineDates.length; i++) {
	        var distanceNorm, eventWidth;
	        if (i == 0) {
	            totalWidth = width;
	        } else {
	            distanceNorm = timelineComponents.timelineDistances[i - 1];
	            eventWidth = timelineComponents.timelineEvents.eq(i - 1).width();
	            totalWidth += eventWidth + distanceNorm * width;
	        }
	    }

	    totalWidth += timelineComponents.timelineEvents.last().width() + width;

	    timelineComponents.eventsWrapper.css('width', totalWidth + 'px');
	    updateFilling(timelineComponents.eventsWrapper.find('a.selected'), timelineComponents.fillingLine, totalWidth);
		updateTimelinePosition('next', timelineComponents.eventsWrapper.find('a.selected'), timelineComponents);
	
		return totalWidth;
	}

	function updateVisibleContent(event, eventsContent) {
		var eventDate = event.data('date'),
			visibleContent = eventsContent.find('.selected'),
			selectedContent = eventsContent.find('[data-date="'+ eventDate +'"]'),
			selectedContentHeight = selectedContent.height();

		if (selectedContent.index() > visibleContent.index()) {
			var classEnetering = 'selected enter-right',
				classLeaving = 'leave-left';
		} else {
			var classEnetering = 'selected enter-left',
				classLeaving = 'leave-right';
		}

		selectedContent.attr('class', classEnetering);
		visibleContent.attr('class', classLeaving).one('webkitAnimationEnd oanimationend msAnimationEnd animationend', function(){
			visibleContent.removeClass('leave-right leave-left');
			selectedContent.removeClass('enter-left enter-right');
		});
		eventsContent.css('height', selectedContentHeight+'px');

		updateTimelineBoxNavigation(event,selectedContent);
	}

	function updateOlderEvents(event) {
		event.parent('li').prevAll('li').children('a').addClass('older-event').end().end().nextAll('li').children('a').removeClass('older-event');
	}

	function getTranslateValue(timeline) {
		var timelineStyle = window.getComputedStyle(timeline.get(0), null),
			timelineTranslate = timelineStyle.getPropertyValue("-webkit-transform") ||
         		timelineStyle.getPropertyValue("-moz-transform") ||
         		timelineStyle.getPropertyValue("-ms-transform") ||
         		timelineStyle.getPropertyValue("-o-transform") ||
         		timelineStyle.getPropertyValue("transform");

        if( timelineTranslate.indexOf('(') >=0 ) {
        	var timelineTranslate = timelineTranslate.split('(')[1];
    		timelineTranslate = timelineTranslate.split(')')[0];
    		timelineTranslate = timelineTranslate.split(',');
    		var translateValue = timelineTranslate[4];
        } else {
        	var translateValue = 0;
        }

        return Number(translateValue);
	}

	function setTransformValue(element, property, value) {
		element.style["-webkit-transform"] = property+"("+value+")";
		element.style["-moz-transform"] = property+"("+value+")";
		element.style["-ms-transform"] = property+"("+value+")";
		element.style["-o-transform"] = property+"("+value+")";
		element.style["transform"] = property+"("+value+")";
	}

	//based on http://stackoverflow.com/questions/542938/how-do-i-get-the-number-of-days-between-two-dates-in-javascript
	function initDatesAndDistances(timelineComponents, events) {
	    var dateArrays = [], dateDistances = [];
	    var wasPrevRange = false, prevRangeStart, prevRangeEnd;
		events.each(function(index){
			var singleDate = $(this),
				dateComp = singleDate.data('date'), isRange = false, currentRangeStart, currentRangeEnd;
			if (String(dateComp).indexOf("-") > 0) {
			    isRange = true;
			    var years = String(dateComp).replace(/\s/g, "").split('-').map(Number);
			    if ((years[0] + years[1]) % 2 == 0) {
			        dateComp = (years[0] + years[1]) / 2;
			    } else {
			        dateComp = Math.round((years[0] + years[1]) / 2);
			    }
			    currentRangeStart = new Date(years[0]);
			    currentRangeEnd = new Date(years[1]);
			}

			var newDate = new Date(dateComp);

			dateArrays.push(newDate);

			var distance;
			if (index > 0) {
			    if (isRange) {
			        if (wasPrevRange) {
			            distance = daydiff(prevRangeEnd, currentRangeStart);
			        } else {
			            distance = daydiff(dateArrays[index - 1], currentRangeStart);
			        }
			    }
			    else {
			        if (wasPrevRange) {
			            distance = daydiff(prevRangeEnd, dateArrays[index]);
			        } else {
			            distance = daydiff(dateArrays[index - 1], dateArrays[index]);
			        }
			    }
			    if (distance == 0)
			        distance = 0.5;
			    else if (distance > 10) {
			        distance = 10;
			    }
			    dateDistances.push(distance);
			}

			wasPrevRange = isRange;
			prevRangeStart = currentRangeStart;
			prevRangeEnd = currentRangeEnd;
		});
		timelineComponents.timelineDates = dateArrays;
		timelineComponents.timelineDistances = dateDistances;
	}

	function daydiff(first, second) {
	    return Math.round((second-first));
	}

	/*
		How to tell if a DOM element is visible in the current viewport?
		http://stackoverflow.com/questions/123999/how-to-tell-if-a-dom-element-is-visible-in-the-current-viewport
	*/
	function elementInViewport(el) {
		var top = el.offsetTop;
		var left = el.offsetLeft;
		var width = el.offsetWidth;
		var height = el.offsetHeight;

		while(el.offsetParent) {
		    el = el.offsetParent;
		    top += el.offsetTop;
		    left += el.offsetLeft;
		}

		return (
		    top < (window.pageYOffset + window.innerHeight) &&
		    left < (window.pageXOffset + window.innerWidth) &&
		    (top + height) > window.pageYOffset &&
		    (left + width) > window.pageXOffset
		);
	}

	function checkMQ() {
		//check if mobile or desktop device
		return window.getComputedStyle(document.querySelector('.cd-horizontal-timeline'), '::before').getPropertyValue('content').replace(/'/g, "").replace(/"/g, "");
	}

	function updateTimelineBoxNavigation(event, selectedContent) {
		prev = $(event).parent().prev();
		next = $(event).parent().next();

		if (prev.length > 0) {
			prevTitle = prev.data('date');
			selectedContent.find('.navigation .prev .text').text(prevTitle);
		}else {
			selectedContent.find('.navigation .prev').addClass('hidden');
		}

		if (next.length > 0) {
			nextTitle = next.data('date');
			selectedContent.find('.navigation .next .text').text(nextTitle);
		}else {
			selectedContent.find('.navigation .next').addClass('hidden');
		}

	}
});
